<header>
  <a [routerLink]="['/']" i18n>Zurück zum Angebot</a>
</header>

<div class="container">
  <h1>Impressum</h1>
  <p>
    <strong>ELITEDOMAINS GmbH</strong><br> Beim Schlump 18<br> 20144 Hamburg, Germany
  </p>
  <p>
    E-Mail: <strong>info&#64;elitedomains.de</strong><br>
  </p>
  <p>
    USt.-ID-Nr.: <strong>DE327584655</strong><br> HRB: 160804, Amtsgericht Hamburg
  </p>
  <p>
    Geschäftsführer: <strong>Jörn Schillmann, Felix Goldstein</strong>
  </p>

  <br><br>
  <p>
    <strong style="font-size: 26px; color: red;">Für Verhandlungen, Fragen oder Einsprüche gegen die Nutzung
      dieser Domain wenden Sie sich bitte direkt an den Domaininhaber, welcher aus dem
      Whois ersichtlich wird. </strong>
  </p>

  <br><br>

  <h2>Wer haftet für Inhalte dieser Domain?</h2>
  <p>
    Für die Domain selbst und die Inhalte auf dieser Domain haftet grundsätzlich der Domaininhaber
    von {{ context.config.name }}. Der Domaininhaber kann über das Interface der ELITEDOMAINS GmbH die dargestellten
    Inhalte selbst wählen, gestalten und in Echtzeit abändern.
  </p>

  <h2>Wer ist Inhaber dieser Domain?</h2>
  <p>
    Der Domaininhaber von {{ context.config.name }} ist nicht die ELITEDOMAINS GmbH. Der Domaininhaber ist über
    die Vergabestelle der jeweiligen Endung zu ermitteln.
  </p>
  <p>
    Beispielsweise ist diese Vergabestelle für .de-Domains die <a
    href="https://denic.de/" target="_blank">DENIC</a>. Sie können den Domaininhaber bei berechtigtem Interesse über die
    Webshois der DENIC ermitteln: <a href="https://webwhois.denic.de/" target="_blank">https://webwhois.denic.de/</a>.
  </p>
  <p>
    Aus Datenschutzgründen darf die ELITEDOMAINS GmbH als Treuhänder keine Inhaberdaten an Dritte herausgeben. Bei
    Unklarheiten wenden Sie sich daher immer an die Vergabestelle dieser Domain.
  </p>

  <h2>ELITEDOMAINS ist nur Treuhänder</h2>
  <p>
    Die ELITEDOMAINS GmbH tritt hier nur als Vermittler, technischer Plattformbetreiber und Treuhänder für den
    Verkauf der Domain {{ context.config.name }} auf. Dafür bietet die ELITEDOMAINS GmbH dem Inhaber eine <a
    href="https://elitedomains.de/domains-verkaufen" target="_blank">technische
    Lösung zur Präsentation und den Verkauf</a> der Domain {{ context.config.name }} an. Die hier
    angebotene Domain wird zusätzlich auch auf dem <a href="https://elitedomains.de/marktplatz"
                                                      target="_blank">Domain-Marktplatz</a> veröffentlicht.
  </p>


  <h2>Informationspflichten</h2>
  <ul>
    <li><a href="https://elitedomains.de/agb">Allgemeine Geschäftsbedingungen</a></li>
    <li><a href="https://elitedomains.de/datenschutz">Datenschutzerklärung</a></li>
    <li><a href="https://elitedomains.de/widerruf">Widerrufsbelehrung</a></li>
  </ul>

  <h2>EU-Streitschlichtung</h2>
  <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:
    <a href="https://ec.europa.eu/consumers/odr/" target="_blank">https://ec.europa.eu/consumers/odr/</a>.
    Unsere E-Mail-Adresse finden Sie oben im Impressum. ELITEDOMAINS ist jedoch nicht verpflichtet, an einem
    Streitschlichtungsverfahren teilzunehmen. </p>

  <h2>Haftungsausschluss</h2>

  <h3>1. Inhalte des Angebotes</h3>
  <p>
    Die ELITEDOMAINS übernimmt keine Garantie für die Korrektheit, Aktualität, Vollständigkeit oder Qualität der hier
    bereitgestellten Informationen. Haftungsansprüche, welche sich auf Schäden materieller oder ideeller Art beziehen,
    die durch die Nutzung oder Nicht-Nutzung dieser Informationen bzw. durch die Nutzung fehlerhafter und
    unvollständiger Informationen verursacht wurden, sind grundsätzlich ausgeschlossen, sofern nicht nachweislich
    vorsätzliches oder grob fahrlässiges Verschulden vorliegt. Alle auf unseren Seiten dargestellten Preise und Angebote
    sind freibleibend und unverbindlich. Es wird ausdrücklich vorbehalten, Teile oder das gesamte Angebot ohne
    gesonderte Ankündigung zu verändern, zu ergänzen, zu löschen oder die Veröffentlichung der Informationen auf diesen
    Seiten zeitweise oder endgültig einzustellen. Durch die bloße Nutzung des Onlineangebotes kommt kein Vertrag
    zwischen dem Nutzer und der ELITEDOMAINS zustande.
  </p>

  <h3>2. Links</h3>
  <p>
    Bei allen von unserem Internetangebot ausgehenden direkten oder indirekten Verweisen auf fremde Internetseiten
    („Links"), die außerhalb des Verantwortungsbereiches der ELITEDOMAINS liegen, kann eine Haftung ausschließlich dann
    in Betracht kommen, wenn der ELITEDOMAINS Kenntnis von den Inhalten, sowie die technische Möglichkeit und
    Zumutbarkeit nachgewiesen werden kann, die Nutzung im Falle rechtswidriger Inhalte zu verhindern. Es wird
    ausdrücklich erklärt, dass auf den verwiesenen Seiten zum Zeitpunkt der Linksetzung keine illegalen Inhalte zu
    erkennen waren. Ein Einfluss auf die Gestaltung, Inhalte oder Urheberschaft der verlinkten Seiten besteht
    unsererseits nicht. Wir distanzieren uns daher ausdrücklich von allen Inhalten aller verlinkten Seiten, die nach der
    Linksetzung verändert wurden. Die Haftung für illegale, fehlerhafte oder unvollständige Inhalte und aus der Nutzung
    oder Nicht-Nutzung dort dargebotener Informationen obliegt einzig dem Anbieter der Seite, auf welche verwiesen
    wurde, nicht demjenigen, der lediglich über einen Link auf die jeweilige Veröffentlichung verweist.
  </p>

  <h3>3. Urheber- und Kennzeichenrechte</h3>
  <p>
    Die ELITEDOMAINS ist bestrebt, in allen Publikationen die Urheberrechte der verwendeten Grafiken, Tondokumente,
    Videosequenzen und Texte zu beachten, von uns selbst erstellte oder lizensierte Grafiken, Tondokumente,
    Videosequenzen und Texte zu nutzen, beziehungsweise lizenzfreie Grafiken, Tondokumente, Videosequenzen und Texte zu
    verwenden. Alle innerhalb unseres Internetangebotes genannten und ggf. durch Dritte geschützten Marken- und
    Warenzeichen unterliegen uneingeschränkt den Bestimmungen des jeweils gültigen Kennzeichenrechts und den
    Besitzrechten der jeweiligen eingetragenen Eigentümer. Die bloße Nennung oder lizensierte Verwendung geschützter
    Inhalte bedeutet nicht, dass diese Inhalte nicht Rechten Dritter unterliegen! Die ELITEDOMAINS behält sich das
    Copyright auf veröffentlichte, von ihr oder ihren Mitarbeitern selbst erstellte Objekte vor. Eine Verwendung oder
    Vervielfältigung solcher Grafiken, Tondokumente, Videosequenzen und Texte in anderen elektronischen, gedruckten oder
    anderen Publikationen ohne ausdrückliche Zustimmung ist nicht gestattet.
  </p>

  <h3>4. Datenschutzbestimmungen</h3>
  <p>
    Sofern innerhalb des Internetangebotes die Möglichkeit zur Eingabe persönlicher oder geschäftlicher Daten besteht,
    so erfolgt die Preisgabe dieser Daten seitens des Nutzers auf ausdrücklich freiwilliger Basis. Die ELITEDOMAINS
    behält sich vor, die eingegebenen Daten zur Beratung und zur Verbesserung des Angebots an die Bedürfnisse der Nutzer
    zu verarbeiten und zu nutzen, sowie zum Zwecke der Durchführung der in Anspruch genommenen Dienstleistungen zu
    speichern und zu verwenden. Die Inanspruchnahme und Bezahlung aller angebotenen Dienste unter Angabe anonymisierter
    Daten oder eines Pseudonyms ist nicht gestattet. Die Eingabe falscher oder unrichtiger Daten führt zum sofortigen
    Verlust der Rechte an der Dienstleistung.
  </p>

  <h3>5. Rechtswirksamkeit</h3>
  <p>
    Dieser Haftungsausschluss ist ein untrennbarer Teil des Internetangebotes, von dem aus auf diese Seite verwiesen
    wurde. Durch die Nutzung des Angebots erklärt der Nutzer, diese Bedingungen gelesen, verstanden und akzeptiert zu
    haben. Sollten Bestimmungen dieses Textes unwirksam sein oder werden, so wird die Wirksamkeit der übrigen
    Bestimmungen nicht berührt. Alle Klauseln, deren rechtliche Anwendung wegen eines rechtlichen Fehlers oder wegen
    Ungültigkeit nicht Anwendung finden können, sollen soweit möglich durch Klauseln ersetzt werden, die rechtlichen
    Bestand haben und der ursprünglichen Absicht am ehesten entsprechen.
  </p>
</div>

<footer class="salePage">
  <div class="container">
    <app-i18n-selector type="bordered"/>

    <p i18n class="ed-footer-paragraph">
      Die Domain {{ context.config.name }} wird auf diesem
      <a [href]="context.links.marketplace|safe" target="_blank">Domain Marktplatz</a>
      angeboten.
    </p>
    <ul class="list-inline">
      <li><a [href]="context.links.promo_index" target="_blank" i18n>ELITEDOMAINS</a></li>
      <li><a [href]="context.links.privacy" target="_blank" i18n>Datenschutz</a></li>
      <li><a [routerLink]="['/impressum']" rel="nofollow" target="_blank" i18n>Impressum</a></li>
    </ul>
  </div>
</footer>
